import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {addPopularMovies} from '../utils/MovieSlice'
import {API_OPTIONS} from '../utils/Constants'


const usePopulorMovies = () =>{
  const dispatch = useDispatch();
 
  const  getPopularMovies = async () =>{
  const data = await fetch("https://api.themoviedb.org/3/movie/popular", API_OPTIONS)
  const json = await data.json();
  dispatch(addPopularMovies(json.results)); 
}

useEffect(()=>{
 getPopularMovies();
},[])}

export default usePopulorMovies;